<template>
  <div>
    <el-select
      v-model="model"
      multiple
      filterable
      allow-create
      default-first-option
      :reserve-keyword="false"
      placeholder="Add keyword"
      size="small"
      @update:modelValue="update"
    >
      <el-option v-for="item in model" :key="item" :label="item" :value="item">
        <span v-html="highlightBanned(item)"></span>
      </el-option>
    </el-select>
    <span v-show="withError" class="el-form-item__error">
      Your search request contains keyword that is prohibited on our platform
      and violate T&C
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useConfigStore } from '@/store/modules/config'

const tagObject: Record<string, string> = {}

export default defineComponent({
  name: 'KeywordsInput',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const configStore = useConfigStore()
    const model = ref(props.modelValue)
    const withError = ref(false)
    const bannedKeywords = computed(() => {
      return configStore.currentConfig.stop_words || []
    })

    const update = (tags: any[]) => {
      const length = tags.length
      let filteredLength = tags.length
      if (bannedKeywords.value.length > 0) {
        const regex = new RegExp(bannedKeywords.value.join('|'))
        filteredLength = tags.filter((tag) => !regex.test(tag)).length
      }
      withError.value = filteredLength !== length
      if (!withError.value) {
        context.emit('update:modelValue', tags)
      }
    }

    const highlightBanned = (tag: string) => {
      if (bannedKeywords.value.length > 0) {
        const regex = new RegExp(bannedKeywords.value.join('|'))
        if (regex.test(tag)) {
          return `<span style="color: red; font-weight: bold;">${tag}</span>`
        }
      }
      return tag
    }

    return { model, update, withError, highlightBanned }
  }
})
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.mobile {
  .el-select {
    width: 100%;
  }
}
</style>
